<template>
  <div>
    <img src="@static/images/bg-1.png" class="bg-1" alt="" />
    <div class="main">
      <img src="@static/images/bg-2.png" class="bg-2" alt="" @click="share()" />
      <ul>
        <li
          v-for="(item, index) in productList"
          :key="index"
          :style="{ backgroundImage: `url(${item.linkUrl})` }"
          @click="showPop(item)"
        >
          <!-- <p class="name">{{ item.productName }}</p> -->
          <!-- <p class="desc">{{ item.information }}</p> -->
          <p class="share" :id="'copy' + item.id">查看详情</p>
        </li>
      </ul>
    </div>
    <bottomNav :active="1"></bottomNav>
    <sharePopup ref="sharePopup" />
    <van-dialog
      v-model="show"
      id="copy"
      @cancel="copyLink(showMsg)"
      @confirm="copyLink(showMsg, 1)"
      confirm-button-text="立即投保"
      cancel-button-text="复制链接"
      close-on-click-overlay
      show-cancel-button
    >
      <div class="msg">
        <p
          v-text="showMsg.commission"
          v-if="showMsg.commission"
          style="white-space: pre-line"
        ></p>
        <p v-else>{{ showMsg.productName }}</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import bottomNav from "@/components/bottomNav.vue";
import sharePopup from "@/components/sharePopup.vue";
import Clipboard from "clipboard";
export default {
  components: {
    bottomNav,
    sharePopup,
  },
  data() {
    return {
      productList: [],
      userInfo: {},
      show: false,
      showMsg: "",
    };
  },
  computed: {},
  created() {
    this.getUserInfo();
    this.$http({
      type: "POST",
      url: "/api/productList",
      data: {},
    }).then((res) => {
      this.productList = res.rows;
    });
  },
  methods: {
    share(item = {}) {
      console.log(item);
      this.$refs.sharePopup?.open(
        item?.insureLink ||
          location.origin + `/app/saveUser?id=${this.userInfo.id}`
      );
      console.log(location.origin + `/app/saveUser?id=${this.userInfo.id}`);
    },
    showPop(item) {
      this.showMsg = item;
      this.show = true;
    },
    copyLink(item, flag) {
      if(flag == 1){
        location.href = item?.insureLink
        return
      }
      var clipboard = new Clipboard("#copy", {
        text: (trigger) => {
          return item?.insureLink;
        },
      });
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
    },
    getUserInfo() {
      this.$http({
        type: "GET",
        url: "/api/getUserDetail",
        data: {},
      }).then((res) => {
        this.userInfo = res.data || {};
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-1 {
  width: 100%;
}
.main {
  padding: 20px 30px;
  .bg-2 {
    width: 100%;
    margin-bottom: 20px;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 1.6rem;
    li {
      height: 220px;
      padding: 20px 30px;
      position: relative;
      border-radius: 15px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .name {
        color: #000;
        font-size: 34px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 35vw;
      }
      .desc {
        color: #a2a1a6;
        font-size: 26px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 35vw;
      }
      .share {
        position: absolute;
        bottom: 30px;
        right: 30px;
        color: #fff;
        background-color: #831e25;
        padding: 0 10px;
        border-radius: 20px;
      }
    }
  }
}
.msg {
  text-align: center;
  padding: 20px;
}
</style>
